// The FRONTEND face of Tecroveer's client config seam.
//
// The screens import these named exports from
// '@client/config/client.config'; in this fork web/vite.config.js points
// that alias HERE, so every client-specific value the screens consume
// comes from the seam, never from code.
//
// ONE SOURCE OF TRUTH: these values mirror client-custom/config/
// client.config.js (the server-side seam). The config suite asserts the
// two never drift — edit BOTH or the runner goes RED.

export const BRAND_NAME = 'Tecroveer';
export const BRAND_TAGLINE = 'World Class Manufacturing and Engineering Systems';
export const BRAND_SUBTITLE = '';
export const APP_TITLE = 'Tecroveer — Zebra Stride';
export const CUSTOMER_LABEL = 'Customer';

// Must match a group name in the site's data (permission checks, admin UI).
export const ADMIN_GROUP = 'site-admins';

// The site-switchers group — membership reveals the site switcher (see
// client-custom/config/client.config.js). The frontend only decides whether to ASK for the
// list; the server decides whether to answer.
export const SITE_SWITCH_GROUP = 'site-switchers';

// Workspaces (see the server seam's workspacesEnabled): ON, as the product
// default. Off = no Settings entry, no /api/workspaces call, nothing drawn.
export const WORKSPACES_ENABLED = true;

// A client's own view of one of its fields on the work item screen (optional — read through the
// namespace by modules/database/work-items/frontend/components/FieldView/fieldViews.js, so a client
// without it builds as before). `field` = the field's name or id; the view loads only when shown:
//   export const FIELD_VIEWS = [{ field: 'GPS Location', load: () => import('@client/customs/x/MyField.jsx') }];
// Optional per entry: `label` (its own words over it on the work item screen) and `collapsible: true`.
// Always through the '@client/customs' alias, never a relative path: web/vite.config.js reads this file
// (APP_TITLE) and Vite bundles its config, so a relative import drags the view into the config bundle and
// the build fails (the field-views suite checks a fork's config for it).

// Browser storage namespace (localStorage, BroadcastChannel).
export const STORAGE_PREFIX = 'tecroveer';

// The architectural hierarchy (see the server seam — whiteboard first).
export const PROJECT_ISSUE_TYPE = '01 Project';
export const MODULE_ISSUE_TYPE = '02 Module';
// Compared case-sensitively by several read paths (coupling: link-case).
export const LINK_TYPE_NAME = 'LINK';

// The field kanban groups/colours by — null until Tecroveer's cloned
// Jira gives a board one (mirrors kanban.groupByFieldId).
export const WPO_FIELD = null;

// Accent colour as RGB (JS canvas + generated chrome).
export const ACCENT_RGB = { r: 245, g: 163, b: 0 };

// Client Customs proxy host allowlist (enforced server-side; mirrored here
// so the seam stays one shape on both faces).
export const CUSTOMS_ALLOWED_HOSTS = [];
